exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__ListRoot__root {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n", ""]);

// exports
exports.locals = {
	"root": "DS__ListRoot__root"
};